import BInput from './packages/BInput'

BInput.install = function(Vue) {
    Vue.component(BInput.name, BInput)
}

export default BInput
